<template>
  <div class="footer-btns vertical">
    <v-btn v-if="ok !== undefined"
           block x-large depressed
           color="primary" class="btn-ok"
           @click="$emit('submit')">
      {{ ok }}
    </v-btn>
    <v-btn v-if="cancel !== undefined"
           color="primary" class="btn-cancel"
           block x-large depressed
           @click="$emit('hide')">{{ cancel }}</v-btn>
    <v-btn v-if="survey !== undefined"
           block x-large depressed
           color="primary" class="btn-ok"
           @click="$emit('next')"
           :disabled="disabledNext">{{ survey }}
    </v-btn>
  </div>
</template>
<script>
export default {
  props: ["ok", "cancel", "survey", "current", "disabledNext"],
}
</script>
